// extracted by mini-css-extract-plugin
export default {"container":"CropPhoto_container__1hYM8","svg":"CropPhoto_svg__7c6Az","zoomContainer":"CropPhoto_zoomContainer__tjH14"};